<template>
  <div
    class="account-info-container"
    :class="{'set-bind-box':page === 3 || (page === 2)}"
  >
    <cube-form
      v-if="page===1"
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item :field="fields[0]" />
      <!-- <captcha-input
        v-model="model.captcha"
        label="图片验证码"
      /> -->
      <div class="cube-form-item-box valid-code-item">
        <cube-form-item :field="fields[1]" />
        <div class="find-pwd-box">
          <get-code
            class="find-pwd-link"
            :mobile="model.mobile"
            type="3"
            :is-disabled="false"
          />
        </div>
      </div>
      <div class="form-btn-box">
        <cube-button
          type="reset"
          :light="true"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
    <bind-dialog
      ref="bindDialog"
      bind-type="mobile"
      :value="model.mobile"
      @showError="getTypeError"
      @setPage="setPage"
    />
    <bind-tips-dialog
      v-if="page===2"
      :value="model.mobile"
      :type-error="typeerror"
    />
    <merge-form
      v-if="page===3"
      @reSetForm="reSetForm"
    />
  </div>
</template>
<script>

import GetCode from '@/components/mobile/GetCode'
import { mapActions, mapState, mapMutations } from 'vuex'
import BindDialog from '@/components/mobile/account/BindDialog'
import BindTipsDialog from '@/components/mobile/account/BindTipsDialog'
import MergeForm from '@/components/mobile/account/MergeForm'
// import CaptchaInput from '@/components/mobile/CaptchaInput'

export default {
  components: {
    GetCode,
    BindDialog,
    BindTipsDialog,
    MergeForm
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      model: {
        mobile: '',
        captcha: '',
        checkcode: ''
      },
      typeerror: 0,
      isTipDShow: false,
      page: 1,
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'mobile',
          label: this.$t('message["1107"]'),
          props: {
            placeholder: this.$t('message["801"]')

          },
          rules: {
            required: true,
            type: 'tel'
          }
        },
        {
          type: 'input',
          modelKey: 'checkcode',
          label: '',
          props: {
            placeholder: this.$t('message["824"]')
          },
          rules: {
            required: true
          }
        }
      ],
      isMergeForm: true
    }
  },
  computed: {
    ...mapState('account/modify', ['']),
    user () {
      const { accountDetail = {} } = this
      const { group = {} } = accountDetail
      const groups = []
      for (let i in group) {
        groups.push(group[i])
      }
      accountDetail.groups = groups.join(' ')
      return accountDetail
    }
  },
  async mounted () {
    // this.$refs.bindDialog.showPopup('myPopup')
  },
  methods: {
    ...mapActions('account/modify', ['bindMobile']),
    ...mapMutations('account/modify', ['setUserid']),
    async submitHandler (e) {
      const chain = await this.bindMobile()
      chain.params(this.model)
        .onSuccess(res => {
          this.$router.push({ name: 'AccountInfo' })
        })
        .onNetSuccess(raw => {
          let res = raw.data
          if (res.error === 104) {
            this.$refs.bindDialog.showPopup('myPopup')
            this.setUserid(res.payload.binduserid)
          } else {
            const toast = this.$createToast({
              time: 2000,
              txt: res.message || res.payload[0].message,
              type: 'txt'
            })
            toast.show()
          }
        })
        .config({ tip: false, warn: false })
        .setForm(this.form)
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    getTypeError (type) {
      this.typeerror = type
      this.page = 2
    },
    resetHandler () {
      this.$router.replace({ name: 'AccountInfo' })
    },
    reSetForm () {
      this.page = 1
    },
    setPage (val) {
      this.page = val
    }
  }
}
</script>
<style lang="scss" scoped>
  .account-info-container::v-deep {
    padding-bottom: 60px;
    .cube-form-item {
      line-height: 56px;
      min-height: 56px;
       .cube-form-label {
        color: #888;
        font-size: 16px;
      }
    }
    .cube-form-item-box .find-pwd-box {
        top: 16px;
      }
  }
  .set-bind-box {
    padding-bottom: 0;
    height: 100%;
  }
</style>
